<template>
  <div class="chat-container">
    <div class="notification" @click="toggle()">
      <v-avatar color="#009e54" size=20 v-if="total_unseen_messages > 0"> {{ total_unseen_messages }} </v-avatar>
    </div>
    <div class="body text-xs-center">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn @click="toggle()" v-on="on" small fab color="#00acc2" dark>
            <v-icon medium>forum</v-icon>
          </v-btn>
        </template>
        <span>Chat</span>
      </v-tooltip>
      <v-layout v-show="showChat" row justify-center>
        <v-dialog v-if="fullscreen" :value="showChat" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <p-chat ref="chat" class="chat" fixed @updateTotalUnseenMessages="updateTotalUnseenMessages" @toggle="toggle" :toggle="this.showChat" @openFullscreen="fullscreen = !fullscreen" :fullscreen="fullscreen"></p-chat>
          </v-card>
        </v-dialog>
        <p-chat v-else-if="showChat" ref="chat" class="chat" v-show="showChat" fixed @updateTotalUnseenMessages="updateTotalUnseenMessages" @toggle="toggle" :toggle="this.showChat" @openFullscreen="fullscreen = !fullscreen" :fullscreen="fullscreen"></p-chat>
      </v-layout>
    </div>
  </div>
</template>

<style scoped>
  .chat-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    z-index: 2;
  }

  .chat {
    z-index: 2 !important;
  }

  .chat-container .notification {
    display: flex;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2 !important;
    border-radius: 50%;
    color: #fff;
  }

  .chat-container .body button {
    margin: 3px !important;
  }

  .badge {
    color: #fff;
  }

  .badge:hover {
    cursor: default;
  }
</style>

<script>
  import PChat from './PChat.vue'

  export default {
    components: {PChat},
    data () {
      return {
        showChat: false,
        fullscreen: false,
        total_unseen_messages: 0
      }
    },
    sockets: {
      getTotalUnseenMessages () {
        this.getTotalUnseenMessages()
      },
      updateTotalBadge (item) {
        // Quando o chat está fechado ou o usuáiro não está na sala que foi adicionado a msg, incrementa 1 no badge
        if (!this.showChat || !this.$refs.chat['selectedItem'] || (item['selectedItem']['id'] !== this.$refs.chat['selectedItem']['id'])) {
          this.updateTotalUnseenMessages(item['type'])
        }
      }
    },
    created () {
      this.fullscreen = this.$vuetify.breakpoint.smAndDown
      // get_total_unseen_messages busca o total de msgs no chat
      this.getTotalUnseenMessages()
    },
    methods: {
      toggle (value = !this.showChat) {
        this.showChat = value
      },
      getTotalUnseenMessages () {
        this.$http.get('api/get_total_unseen_messages').then(res => {
          this.total_unseen_messages = res.body
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar o total de mensagens no chat. Favor reportar o erro.`,
            color: 'error',
            dialog: true
          })
        })
      },
      // usado no in.vue para abrir o chat da illis
      openChatIllis () {
        this.$refs.chat.firstTimeChat = true
        this.showChat = true
      },
      updateTotalUnseenMessages (data) {
        console.log('updateTotalUnseenMessages', data)
        // se o data for add adicionar 1, se for del tira um e se não for nenhum deles recebe a quantidade que veio no data
        if (data === 'add') {
          this.total_unseen_messages++
        } else if (data === 'del') {
          this.total_unseen_messages--
        } else {
          this.total_unseen_messages = data
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PChatLauncher.vue